import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
 return Cookies.get(TokenKey)
  //  return 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ3ZWIiLCJpc3MiOiJ3bS10aXMiLCJleHAiOjE2NTk3MDMwMzQsImlhdCI6MTY1OTY2NzAzNCwianRpIjoiMzdmMjIxMjBhZmY2NGVkYTk1YzM5M2Y5MjcxZTg5ZjAiLCJ1c2VybmFtZSI6InNpeXVhbi5zaGFuZyJ9.ewBkF58NXL5A18uVIZf-ks0wwJA-sH8FsJZCJU5Qwlk'
  }

export function setToken(token) {
  return Cookies.set(TokenKey, token)
   //  return 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJ3ZWIiLCJpc3MiOiJ3bS10aXMiLCJleHAiOjE2NTk3MDMwMzQsImlhdCI6MTY1OTY2NzAzNCwianRpIjoiMzdmMjIxMjBhZmY2NGVkYTk1YzM5M2Y5MjcxZTg5ZjAiLCJ1c2VybmFtZSI6InNpeXVhbi5zaGFuZyJ9.ewBkF58NXL5A18uVIZf-ks0wwJA-sH8FsJZCJU5Qwlk'
  }

export function removeToken() {
  return Cookies.remove(TokenKey)
}
